import React, { Ref, ReactNode } from "react";

import "./LinkButton.scss";

interface LinkButtonProps extends React.PropsWithChildren<any> {
  "aria-expanded"?: boolean;
  "aria-haspopup"?:
    | "dialog"
    | "menu"
    | "true"
    | "false"
    | "listbox"
    | "tree"
    | "grid";
  "aria-label"?: string;
  color?: "blue" | "red" | "grey" | "steel";
  nocolor?: boolean;
  title?: string;
  onClick?: Function;
  children?: ReactNode;
  disabled?: boolean;
}

/**
 * This is a Button that looks like a link (nothing to do with react-router Link).
 */
const LinkButton = React.forwardRef(
  (props: LinkButtonProps, ref: Ref<HTMLButtonElement>) => {
    const {
      "aria-label": ariaLabel,
      "aria-haspopup": ariaHasPopup,
      "aria-expanded": ariaExpanded,
      color = "blue",
      nocolor,
      title,
      onClick,
      children,
      disabled,
      className,
    } = props;

    const ariaProps = {
      "aria-label": ariaLabel,
      "aria-haspopup": ariaHasPopup,
      "aria-expanded": ariaExpanded,
    };

    return (
      <button
        {...ariaProps}
        className={[
          "LinkButton",
          nocolor ? "" : `LinkButton__${color}`,
          className || "",
        ].join(" ")}
        onClick={(e) => {
          onClick && onClick(e);
        }}
        title={title}
        disabled={disabled}
        ref={ref}
      >
        {children}
      </button>
    );
  }
);

export default LinkButton;
